import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import TenantDetailsContainer from '../containers/tenant-details.container';
import TenantUpdateContainer from '../containers/tenant-update.container';
import TenantGuard from '@components/common/TenantGuard';

export const tenantRoutes = [
  {
    path: 'tenant',
    element: (
      <TenantGuard showHeader={true} headerTitle="Tenant Details" showBreadcrumbs={true}>
        <TenantDetailsContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'tenant/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update Tenant" showBreadcrumbs={true}>
        <TenantUpdateContainer />
      </TenantGuard>
    ),
  },
];

export default tenantRoutes;
